import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { useDownloadMarginReportData } from "@/lib/api/otc";
import { BearDatePicker } from "../ContractForm";
import { ReportCard, ReportDownloadLink } from "./ReportCard";

interface MarginReportFilters {
  after_date?: Date;
  before_date?: Date;
}

/**
 * Margin Report — after / before date filters. Generate downloads a single link.
 */
export function MarginReportCard() {
  const { toast } = useToast();
  const downloadDataLinkFunc = useDownloadMarginReportData();
  const [filters, setFilters] = useState<MarginReportFilters>({});
  const [link, setLink] = useState<string | undefined>(undefined);
  const [isDownloading, setIsDownloading] = useState(false);

  const onGenerate = async () => {
    if (isDownloading) return;
    setLink(undefined);
    setIsDownloading(true);

    const result = await downloadDataLinkFunc(filters);

    if (!result.success) {
      toast({ title: "Failed to generate", description: "" });
    } else {
      setLink(result.data.link);
    }

    setIsDownloading(false);
  };

  return (
    <ReportCard
      title="Margin Report"
      description="Generate a margin report for a date range."
      isDownloading={isDownloading}
      onGenerate={onGenerate}
      hasResults={!!link}
      linkContent={link ? <ReportDownloadLink href={link} label="Download Report" /> : null}
    >
      <div className="grid grid-cols-1 gap-3">
        <BearDatePicker
          tabIndex={0}
          name="margin_report_after_date"
          label="After Date"
          value={filters.after_date}
          onValueChange={(date: Date | undefined) =>
            setFilters((prev: MarginReportFilters) => ({ ...prev, after_date: date }))
          }
        />
        <BearDatePicker
          tabIndex={1}
          name="margin_report_before_date"
          label="Before Date"
          value={filters.before_date}
          onValueChange={(date: Date | undefined) =>
            setFilters((prev: MarginReportFilters) => ({ ...prev, before_date: date }))
          }
        />
      </div>
    </ReportCard>
  );
}
